module.exports = __webpack_public_path__ + "static/media/user-6.55be79ba.png";